var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBarChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_basic_bar",
    transform: "rotate(90 53.344 -11.656)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14072",
    "data-name": "Rectangle 14072",
    width: 32,
    height: 32,
    transform: "translate(65 9.688)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_basic_bar-2",
    "data-name": "ico_basic_bar",
    transform: "translate(68.128 -104.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53965",
    "data-name": "Path 53965",
    d: "M154.29,234h-2.934a.841.841,0,0,0-.73.919V255.7a.841.841,0,0,0,.73.919h2.934a.841.841,0,0,0,.73-.919V234.92A.841.841,0,0,0,154.29,234Z",
    transform: "translate(-142.889 -113.127)",
    fill: "#06c270"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53966",
    "data-name": "Path 53966",
    d: "M274.79,200.776h-2.934a.86.86,0,0,1-.73-.946V183.7a.859.859,0,0,1,.73-.946h2.934a.859.859,0,0,1,.73.946V199.83A.859.859,0,0,1,274.79,200.776Z",
    transform: "translate(-257.52 -57.277)",
    fill: "#00cfde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53966-2",
    "data-name": "Path 53966",
    d: "M274.79,200.655h-2.934a.86.86,0,0,1-.73-.946V190.7a.859.859,0,0,1,.73-.946h2.934a.859.859,0,0,1,.73.946v9.012A.859.859,0,0,1,274.79,200.655Z",
    transform: "translate(-269.256 -57.156)",
    fill: "#36adfc",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53967",
    "data-name": "Path 53967",
    d: "M395.291,144.5h-2.934a.842.842,0,0,1-.731-.919V119.42a.842.842,0,0,1,.731-.919h2.934a.842.842,0,0,1,.73.919v24.159A.842.842,0,0,1,395.291,144.5Z",
    transform: "translate(-372.15 -1.002)",
    fill: "#be88f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53969",
    "data-name": "Path 53969",
    d: "M197.218,234h-1.467v22.624h1.467a.841.841,0,0,0,.731-.919V234.92A.841.841,0,0,0,197.218,234Z",
    transform: "translate(-185.815 -113.126)",
    fill: "#019a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53970",
    "data-name": "Path 53970",
    d: "M317.718,182.751h-1.467v18.025h1.467a.86.86,0,0,0,.73-.946V183.7A.859.859,0,0,0,317.718,182.751Z",
    transform: "translate(-300.446 -57.277)",
    fill: "#06b1be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54009",
    "data-name": "Path 54009",
    d: "M317.718,189.751h-1.467v10.9h1.467a.86.86,0,0,0,.73-.946V190.7A.859.859,0,0,0,317.718,189.751Z",
    transform: "translate(-312.183 -57.156)",
    fill: "#2174d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53971",
    "data-name": "Path 53971",
    d: "M438.218,118.5h-1.467v26h1.467a.842.842,0,0,0,.731-.919V119.42A.841.841,0,0,0,438.218,118.5Z",
    transform: "translate(-415.078 -1.002)",
    fill: "#9665c7"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBarChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_bar_chart.c83ed42d120a918b6aa58eaa54a6bb22.svg";